<script>
export default {
	computed:{
		manager: function(){
			return this.$store.getters.getManager();
		}
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/vuex/manager/read.mixin.vue